module.exports = __webpack_public_path__ + "images/vibecode_logo.svg";


//////////////////
// WEBPACK FOOTER
// ./images/vibecode_logo.svg
// module id = 14
// module chunks = 1